export const INSTALLATION_DEFAULT_CONSTANTS = {
    installationDesc1: '',
    installationDesc2: '',
    installationDesc3: '',
    installationDesc4: '',
    installationDesc5: '',
    wasCreatedFromImport: false,
}